export interface AttendeeSummary {
  totalAttendees?: number,
  totalAdults?: number,
  totalKids?: number,
  maybeTotalAttendees?: number,
  maybeAdults?: number,
  maybeKids?: number,
}

export interface CampaignRecipient {
  cfaID: string,
  rewardStatus: RewardStatus,
  emailStatus: EmailStatus,
  eventRecipientRsvpStat: EventRecipientRsvpStat,
  dates?: string,
  firstName?: string,
  lastName?: string,
  droppedFromSpotlight?: boolean,
  adultsAttending?: number,
  kidsAttending?: number,
}

export enum RewardStatus {
  Pending = 'Pending',
  Loaded = 'Received',
  Failed = 'There was an error sending this reward.',
  DuplicateRewardExclusion = 'Customer was not sent this reward as they already have a reward for this item.',
  LocationRewardExclusion = 'Customer was not sent this reward as they already have a reward from your location.',
  RedeemedIssuedLocation = 'Reward redeemed at your location.',
  RedeemedOtherLocation = 'Reward redeemed at a location other than yours.',
}

export enum EmailStatus {
  Pending = 'Pending',
  NotAttempted = 'Email send was not attempted because the reward did not send.',
  Failed = `Email could not be delivered due to a possible issue with the recipient's email.`,
  FailedProcessing = 'Email processing failed.',
  Dropped = 'Email could not be delivered because the recipient has unsubscribed, marked as spam, or the email address is invalid.',
  Sent = 'Sent',
  Delivered = 'Delivered',
  Opened = 'Opened',
  Spam = 'Recipient marked this email as spam.',
  Unsubscribed = 'Recipient unsubscribed based on this email.',
}

export enum EventStatus {
  Going = 'Going',
  NotGoing = 'Not Going',
  Maybe = 'Maybe',
}

export interface EventRecipientRsvpStat {
  status: EventStatus;
  adultsAttending?: number;
  kidsAttending?: number;
}

